module.exports = __webpack_public_path__ + "static/media/Shenhe.cb95a5b5.png";